/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedLayout_user = {
    readonly " $fragmentRefs": FragmentRefs<"SharedTrackingContainer_user">;
    readonly " $refType": "PdpSharedLayout_user";
};
export type PdpSharedLayout_user$data = PdpSharedLayout_user;
export type PdpSharedLayout_user$key = {
    readonly " $data"?: PdpSharedLayout_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedLayout_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedLayout_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedTrackingContainer_user",
      "args": null
    }
  ]
};
(node as any).hash = '4d055eca3cf7a8b680bf82157ea283dc';
export default node;
